import { Model } from "../../model";
import { Sector } from "./sector";
import { Field } from "./field";

export class Farm implements Model {
    _id: string;
    description: string;
    administrativeUnitId: string;
    sectors: Sector[];

    constructor(obj: any) {
        this._id = obj._id;
        this.description = obj.description;
        this.administrativeUnitId = obj.administrativeUnitId;
        this.sectors = obj.sectors;
    };

    public getFields(): Field[] {
        const fields = this.sectors
            .map(sector => sector.fields)
            .reduce((f1, f2) => f1.concat(f2), []);
        return fields;
    }

    public removeField(field: Field): void {
        this.sectors.forEach(s => s.fields.splice(s.fields.findIndex(f => new Field(f).getFieldKey() == field.getFieldKey()), 1));
    }

    public getProductionPeriodIds(): string[] {
        const periodIds = this.sectors
            .map(sector => sector.fields)
            .reduce((f1, f2) => f1.concat(f2), [])
            .map(field => field.productionPeriodId)
            .reduce((p1, p2) => p1.concat(p2), [])
            .filter( ( elem, index, arr ) => arr.indexOf( elem ) === index );

        return periodIds;
    }

    public containsProductionPeriodId(idPeriod: string): boolean {
        let contains = false;
        this.sectors
            .map(sector => sector.fields
                .map(field => {
                    if(field.productionPeriodId == idPeriod) contains = true;
                }));

        return contains;
    }

    public getVarietyIds(): string[] {
        const varietyIds = this.sectors
            .map(sector => sector.fields)
            .reduce((f1, f2) => f1.concat(f2), [])
            .map(field => field.varietyId)
            .reduce((v1, v2) => v1.concat(v2), [])
            .filter( ( elem, index, arr ) => arr.indexOf( elem ) === index );

        return varietyIds;
    }

}